module.exports = __webpack_public_path__ + "media/images/profile/mail-circle-1764927e62db365fd4e69898fa5a440e.svg";